export {
  SearchDropdown,
  type GroupedHits,
  type GroupedStores,
  type SearchDropdownProps,
} from './SearchDropdown';
